import * as THREE from './three'
import { Layers } from './Layers'

const DOWN = new THREE.Vector3(0, -1, 0)
const UP = new THREE.Vector3(0, 1, 0)
// Spheres along the 0.3 m player capsule, with a margin, kept above the floor
// so the ground itself never counts as an obstacle.
const PROBE_RADIUS = 0.4
const PROBE_HEIGHTS = [0.55, 1.0, 1.45]
const MAX_STEP = 0.5 // floor height difference accepted from the reference
const v1 = new THREE.Vector3()
const v2 = new THREE.Vector3()

// True when the player capsule standing with its feet at `feet` overlaps no environment/prop collider.
export function isPositionClear(physics, feet) {
  const mask = Layers.environment.group | Layers.prop.group
  return !PROBE_HEIGHTS.some(height => physics.overlapSphere(PROBE_RADIUS, v1.copy(feet).setY(feet.y + height), mask).length > 0)
}

/**
 * Finds a standing position clear of environment/prop colliders, searching
 * outward from `origin` along `forward` (horizontal), then fanning to the sides.
 * Returns feet position on the floor, or null when no candidate is clear.
 */
export function findClearPosition(physics, origin, forward, { from = 2.4, to = 5, step = 0.3, angles = [0, 30, -30, 60, -60, 90, -90] } = {}) {
  const mask = Layers.environment.group | Layers.prop.group
  const dir = v2.copy(forward).setY(0)
  if (dir.lengthSq() === 0) dir.set(0, 0, -1)
  dir.normalize()
  for (let distance = from; distance <= to + 1e-6; distance += step) {
    for (const angle of angles) {
      const candidate = new THREE.Vector3()
        .copy(dir)
        .applyAxisAngle(UP, THREE.MathUtils.degToRad(angle))
        .multiplyScalar(distance)
        .add(origin)
      // Floor under the candidate, at about the same height as the origin.
      const ground = physics.raycast(v1.copy(candidate).setY(origin.y + 2), DOWN, 4, mask)
      if (!ground || ground.normal.y < 0.7 || Math.abs(ground.point.y - origin.y) > MAX_STEP) continue
      candidate.y = ground.point.y
      if (isPositionClear(physics, candidate)) return candidate
    }
  }
  return null
}
